var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { html, LitElement } from 'lit';
import { helper } from "../../common/helper";
import css from './style.pcss';
import Flickity from "flickity";
import * as dayjs from "dayjs";
var MAX_EPISODES = 10;
var RTLPlayEpisodeSlider = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLPlayEpisodeSlider, _LitElement);
  function RTLPlayEpisodeSlider() {
    var _this;
    _classCallCheck(this, RTLPlayEpisodeSlider);
    _this = _callSuper(this, RTLPlayEpisodeSlider);
    _this.language = "lu";
    _this.loading = false;
    _this.apiUrl = 'https://play-api.rtl.lu/v3';
    _this.style = 'default';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    _this.location = window.location.origin;
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
    }
    return _this;
  }
  _createClass(RTLPlayEpisodeSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLPlayEpisodeSlider.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.loading = true;
      if (this.language === 'lu') this.language = 'lb';
      this.apiUrl = `${this.apiUrl}/emissions/${this.slug}/episodes?lang=${this.language}&include=emission`;
      console.log(this.apiUrl);
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;

        // if (this.data.length > 10) this.data.length = 10;
        //console.log(this.data);
        _this2.loading = false;
      });
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e, url) {
      helper.openPlayLink(url);
    }
  }, {
    key: "renderEpisodeCard",
    value: function renderEpisodeCard(episode) {
      var _this3 = this;
      var emissionUrl = `https://play.rtl.lu${episode._links.web}`;
      return html(_t || (_t = _`<div class="slider__item">
                        <div class="card card--overlay">
                            <div class="card__media-wrapper">
                                <div class="card__media">

                                    <div class="media-image">
                                        <div class="media-image__container">
                                            <img class="media-image__image  responsive-img" src="${0}" loading="lazy" alt="RTL">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card__content">
                                <div class="card__header">
                                    <div class="card___mtitle">
                                        <a href="${0}"><span class="card__title">${0}</span></a>
                                    </div>
                                </div>
                                <div class="card__date">${0}</div>
                            </div>
                            <a class="block-link__overlay" @click=${0}>${0}</a>
                        </div>
                    </div>`), helper.stockify(episode.thumbnail, 700), emissionUrl, episode.name, dayjs(episode.date).format('DD/MM/YYYY'), function (e) {
        return _this3._handleClick(e, emissionUrl);
      }, episode.name);
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      var _this4 = this;
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="rtl-play-episode-slider" style="background-image: url(${0})">
                <div class="rtl-play-episode-slider__header">
                    <img src="${0}"  class="rtl-play-episode-slider__logo" />
                </div>
                <div class="rtl-play-episode-slider__slider">
                    <div class="slider">
                        ${0}
                    </div>
                </div>
            </div>
        `), css, this.data.emission.images.landscape, this.data.emission.logo, this.data.episodes.filter(function (v, i) {
        return i < MAX_EPISODES;
      }).map(function (episode) {
        return _this4.renderEpisodeCard(episode);
      }));
    }
  }, {
    key: "_renderNoVisuals",
    value: function _renderNoVisuals() {
      var _this5 = this;
      return html(_t3 || (_t3 = _`
            <style>${0}</style>
            <div class="rtl-play-episode-slider rtl-play-episode-slider--novisuals">
                ${0}
                <div class="rtl-play-episode-slider__slider">
                    <div class="slider">
                        ${0}
                    </div>
                </div>
            </div>
        `), css, this.title ? html(_t4 || (_t4 = _`
                    <div class="rtl-play-episode-slider__title">
                        <span class="rtl-play-episode-slider__title-text">${0}</span>
                    </div>`), this.title) : '', this.data.episodes.filter(function (v, i) {
        return i < MAX_EPISODES;
      }).map(function (episode) {
        return _this5.renderEpisodeCard(episode);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      if (this.data == undefined) return;
      this.updateComplete.then(function () {
        if (!_this6.flickity) {
          var slider = _this6.querySelector('.slider');
          _this6.flickity = new Flickity(slider, {
            groupCells: false,
            wrapAround: true,
            pageDots: true,
            cellAlign: 'center',
            contain: true,
            adaptiveHeight: false
          });
        }
      });
      if (this.style === 'default') return this._renderDefault();else return this._renderNoVisuals();
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        loading: {
          type: Boolean
        },
        slug: {
          type: String
        },
        language: {
          type: String
        },
        style: {
          type: String
        },
        title: {
          type: String
        }
      };
    }
  }]);
  return RTLPlayEpisodeSlider;
}(LitElement);
export { RTLPlayEpisodeSlider as default };
window.customElements.define('rtl-play-episode-slider', RTLPlayEpisodeSlider);